<div class="header-2024-sm">
    <div class="header-start">
        @if (icon === 'close') {
            <!-- eslint-disable @angular-eslint/template/no-autofocus -->
            <button aria-label="Close menú" class="btn-link header-close topbar-link pl-2 header-menu-icon" (click)="closeMenu()" autofocus>
                <md-icon name="close"></md-icon>
            </button>
        }

        @if (icon === 'bars') {
            <button aria-label="Open menu" class="btn-link header-open topbar-link header-menu-icon" (click)="openMenu()">
                <md-icon name="menu-ham"></md-icon>
            </button>
        }

        <a
            class="header-logo topbar-link"
            [class.hidden-logo]="hiddenLogo"
            [class.ml-4]="icon === 'close'"
            (click)="goToHome($event)"
            [href]="latestHomeSeoUrl"
            [attr.aria-label]="'HOME ' + lastSection"
        >
            <div class="header-menu-icon">
                <md-icon name="md-logo" style="max-width: 120px"></md-icon>
            </div>
        </a>
    </div>
    <div class="header-end">
        @if ((isSearchPage$ | async) === false) {
            <button
                [attr.aria-label]="'header_search' | translate"
                class="btn-link header-search-sm topbar-link header-menu-icon"
                (click)="openSearch()"
            >
                <md-icon name="search"></md-icon>
            </button>
        }

        @if (isOpenForSale) {
            <button
                [attr.aria-label]="'header_my_account' | translate"
                class="btn-link header-login-sm topbar-link header-menu-icon"
                style="display: flex; align-items: center"
                (click)="login()"
            >
                @defer (when isLogged) {
                    <md-icon name="user-logged"></md-icon>
                } @placeholder {
                    <md-icon name="user"></md-icon>
                }
            </button>

            <button [attr.aria-label]="'header_shop_cart' | translate" class="btn-link header-bag-sm topbar-link" (click)="openShopCart()">
                <div class="header-menu-icon">
                    <md-icon name="cesta"></md-icon>
                </div>
                <div class="topbar-link">
                    @if (cartItems > 0) {
                        <span class="cart-items topbar-link">({{ cartItems }})</span>
                    }
                </div>
            </button>
        }
    </div>
</div>
